import config from './config';

/* eslint-disable no-console */
export const log = (message) => {
  console.warn(`[vue-analytics] ${message}`);
};
/* eslint-enable no-console */

export function merge(obj, src) {
  Object.keys(src).forEach(function (key) {
    const type = obj[key] && Object.prototype.toString.call(obj[key]);
    if (type === '[object Object]' || type === '[object Array]') {
      merge(obj[key], src[key]);
      return;
    }
    obj[key] = src[key];
  });

  return obj;
}

export function isRouteIgnored({ name, path }) {
  return [name, path].filter(Boolean).find((value) => config.ignoreRoutes.indexOf(value) !== -1);
}

export function isRoute(data) {
  return data.query && data.params;
}

export function isRouter(data) {
  return data.currentRoute;
}

export function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
